import React from 'react';
import AppIcon from './AppIcon';
import muralDefault from '../../assets/images/mural-default.png'
import contributorDefault from '../../assets/images/contributor-default.png'

const MuralCard = () => {
  return (
    <article className="bg-white flex flex-col">
      <img src={muralDefault} alt="" className="w-full" />

      <div className="p-2.5 flex flex-col flex-1 items-start w-full">
        <div className="flex-1 w-full">
          <div className="flex gap-3 mb-3 items-start">
            <p className="font-folio uppercase flex-1 text-2xl text-black-800 leading-none">Mural name</p>
            <button ><AppIcon className="h-5" name="heart"/></button>
            <button ><AppIcon className="h-5" name="menu"/></button>
          </div>

          <div className="flex gap-2 mb-1">
            <AppIcon name="artist" className="relative top-px w-4 h-4 text-primary"/>
            <p className="font-din uppercase text-lg text-gray-400 flex-1 leading-5">Artist</p>
          </div>
        </div>

        <p className="bg-gray-50 rounded py-1 px-2 inline-flex text-xs text-gray-500 font-semibold gap-1">
          <img
            src={contributorDefault} alt=""
            className="h-4 w-4 rounded-full border border-gray-200"
          />
          <span>Posted by Dave Lee</span>
        </p>
      </div>
    </article>
  )
}

export default MuralCard;